<template>
    <v-layout align-center justify-center column fill-height>
            <v-card max-width="618px"  hover> 
                <v-card-title 
                    class="headline orange darken-3" primary-title >
                    {{titulto}}
                </v-card-title>
                <v-card-text v-html="descripcion">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text 
                  v-show="isLogin">
                    <h1 class="green--text" >ACCESO CONCEDIDO</h1>
                    <div v-for="(sec,i) in contenido" :key="i">
                        <h1>{{sec.seccion}}</h1>
                        <br>
                        <div v-for="(v,e) in sec.aVideos" :key="e"
                            v-html="v">
                            <br>  
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions
                  v-show="!isLogin">
                    <v-btn color="primary" flat @click="dLogin = true" >
                    Ver Videos
                    </v-btn>
                </v-card-actions>
            </v-card>

            <v-dialog v-model="dLogin" max-width="290">
                <v-card>
                    <v-card-title class="headline">Ingrese la contraseña</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="uInput" required ></v-text-field>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn  @click="dLogin = false" >
                            Cancelar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

    </v-layout>
</template>

<script>
  export default {
    props : ["datos"],
    beforeMount(){
        if (this.datos != null){
            Object.assign( this.$data, this.datos)
        }
    },
    data() {
      return {
          titulto       : "Profesorado de YOGA X"
         ,descripcion   : " Este curso incluye bla bla bla." 
         ,pClave        : "escuela"
         ,contenido     : null
         ,dLogin        : false
         ,uInput        : ""
      }
    },
    watch:{
        isLogin:function(newV){
            if(newV){
                this.dLogin=false
            }
        }
    },
    computed:{
        isLogin(){
            return (this.pClave==this.uInput)
        }
    }
  }
</script>

<style scoped>
green {
    color: green 
    }
</style>
